// extracted by mini-css-extract-plugin
export default {"deleteButton":"DeleteButton_deleteButton__Whyju","withName":"DeleteButton_withName__5j7oT"};